export const MOVE_ASSET_INTO_AUCTION_EVENT = 'AuctionEvent';
export const MOVE_ASSET_BACK_TO_OPPORTUNITY = 'BackToOpportunity';
export const MOVE_ASSET_INTO_HOLDING_PEN = 'HoldingPen';
export const MOVE_ASSET_INTO_OTHER_OPPORTUNITY = 'OtherOpportunity';
export const MOVE_ASSET_INTO_OTHER_CONTRACT = 'OtherContract';
export const MOVE_ASSET_BACK_TO_WIP = 'BackToWip';
export const SEND_ASSETS_TO_OPERATIONS = 'SendToOperations';
export const RESELL_COLLAPSE_TO_INVENTORY = 'ResellCollapsedToInventory';
export const RESELL_COLLAPSE_TO_SELLER = 'ResellCollapsedToSeller';
export const RESELL_NOT_SOLD = 'ResellNotSold';
export const RETURN_TO_PREVIOUS_SALE='ReturnToPreviousSale';
export const RESELL_ASSET='ResellAsset';

export enum assetMoveDestinationTypeName {
  BackToWip = 'Back To WIP',
  BackToOpportunity = 'Pull Lot',
  HoldingPen = 'Holding Pen',
  OtherOpportunity = 'Other Opportunity',
  OtherContract = 'Other Contract',
  AuctionEvent = 'Event/ Channel',
  ReturnToPrevEvent='Previous Event',
  ResellITem = 'Resell'
}
